// 宿主可选择接入策略；未接入的应用保持原有行为。
interface CustomFieldPolicy {
    readonly textCustomFieldDisabled: boolean;
    isFieldEnabled(field: any): boolean;
    isFieldIdEnabled(id: string): boolean;
    isSearchFieldEnabled(field: any): boolean;
    filterFields(fields: any[]): any[];
    prepareFields(fields: any[]): Promise<void>;
}

let policy: CustomFieldPolicy | undefined;

export function configureCustomFieldPolicy(value?: CustomFieldPolicy) {
    policy = value;
}

export function hasCustomFieldPolicy() {
    return !!policy && policy.textCustomFieldDisabled;
}

export function isCustomFieldEnabled(field: any) {
    return !policy || policy.isFieldEnabled(field);
}

export function isCustomFieldIdEnabled(id: string) {
    return !policy || policy.isFieldIdEnabled(id);
}

export function isCustomSearchFieldEnabled(field: any) {
    return !policy || policy.isSearchFieldEnabled(field);
}

export function filterCustomFields<T>(fields: T[]): T[] {
    return policy ? policy.filterFields(fields) : fields;
}

export function prepareCustomFieldPolicy(fields: any[]) {
    return policy ? policy.prepareFields(fields) : Promise.resolve();
}
